import { createFileRoute } from "@tanstack/react-router";
import { cmsRouteConfig, DecoPageRenderer } from "@decocms/tanstack";
import { deferredSectionLoader } from "@decocms/tanstack/sdk/deferredSectionLoader";
import { withCanonicalFallback } from "~/utils/seo";

// CMS `Site.seo` overrides these per-page once block resolution kicks in.
const routeConfig = cmsRouteConfig({
  siteName: "Daniela Tombini",
  defaultTitle: "Daniela Tombini: Pijamas Femininos, Lingerie, Biquíni, Fitness, Praia",
  defaultDescription: "Pijamas Femininos, Masculinos e Infantis, Lingerie, Biquíni e Fitness na Loja Daniela Tombini. Vendas por Atacado e Varejo.",
  ignoreSearchParams: ["skuId"],
});

export const Route = createFileRoute("/$")({
  ...routeConfig,
  head: withCanonicalFallback(routeConfig.head),
  component: CmsPage,
  notFoundComponent: NotFoundPage,
});

function CmsPage() {
  const data = Route.useLoaderData() as Record<string, any> | null;
  if (!data) return <NotFoundPage />;

  return (
    <DecoPageRenderer
      sections={data.resolvedSections ?? []}
      deferredSections={data.deferredSections ?? []}
      deferredPromises={data.deferredPromises}
      pagePath={data.pagePath}
      pageUrl={data.pageUrl}
      loadDeferredSectionFn={deferredSectionLoader}
    />
  );
}

function PendingPage() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <span className="loading loading-ring loading-xl" />
    </div>
  );
}

// Só aparece se nenhum bloco de página do CMS casar com a URL — na prática
// a categoria `/*` pega tudo e a URL inexistente cai no "ESSA PÁGINA NÃO
// EXISTE" da busca (com status 404, ver src/server/pageStatus.ts). Mantida
// como rede de segurança, no mesmo tom.
function NotFoundPage() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-5">
      <div className="text-center">
        <h1 className="font-['Poppins'] text-[24px] lg:text-[30px] font-medium uppercase tracking-tight text-[#333333]">
          Essa página não existe
        </h1>
        <p className="mt-3 text-[15px] text-[#5C5C5C]">
          O endereço pode ter mudado ou a página foi removida.
        </p>
        <a
          href="/"
          className="inline-block mt-6 px-6 py-3 border border-[#1A1A1A] text-[13px] uppercase tracking-[0.08em] hover:bg-[#1A1A1A] hover:text-white transition-colors"
        >
          Voltar para a loja
        </a>
      </div>
    </div>
  );
}
